import {
  ButtonsDiv,
  LimitMessage,
  LimitMessageContainer,
} from '../LocalFilterSection.styles';
import { Button } from 'src/components/atoms';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';

interface ShowMoreOptionsProps {
  options: string[] | { label: string; description?: string }[];
  optionsDisplaying: number;
  setOptionsDisplaying: (value: number) => void;
  initialOptionsDisplaying: number;
  limitMessage?: string;
}
export const ShowMoreOptions = ({
  options,
  optionsDisplaying,
  initialOptionsDisplaying,
  limitMessage,
  setOptionsDisplaying,
}: ShowMoreOptionsProps) => {
  return (
    <>
      {options.length > initialOptionsDisplaying ? (
        <ButtonsDiv>
          <Button
            variant="tertiary"
            size="medium"
            onClick={() =>
              setOptionsDisplaying(
                options.length > optionsDisplaying
                  ? options.length
                  : initialOptionsDisplaying,
              )
            }
            data-testid={'view-more-button'}
          >
            {options.length > optionsDisplaying ? 'View more' : 'View less'}
            <StyledIconInButton
              size="medium"
              position="right"
              className={`uil uil-angle-${
                options.length > optionsDisplaying ? 'down' : 'up'
              }`}
            />
          </Button>
          {limitMessage && (
            <LimitMessage data-testid="filter-limit-message">
              {limitMessage}
            </LimitMessage>
          )}
        </ButtonsDiv>
      ) : (
        limitMessage && (
          <LimitMessageContainer>
            <LimitMessage data-testid="filter-limit-message">
              {limitMessage}
            </LimitMessage>
          </LimitMessageContainer>
        )
      )}
    </>
  );
};
